<div class="content">
  <form
    class="form"
    [formGroup]="turnkeyCostFormGroup()"
  >
    @for (field of turnkeyCostFields; track $index) {
      @switch (field.type) {
        @case ('number') {
          <mat-form-field
            appearance="outline"
            class="form-field"
            [class]="getFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              [type]="field.inputType || 'number'"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            >
          </mat-form-field>
        }
        @case ('date') {
          <mat-form-field
            appearance="outline"
            class="form-field"
            [class]="getFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              appDateInput
              placeholder="ДД.ММ.ГГГГ"
              [matDatepicker]="picker"
              [formControlName]="field.fieldName"
              (dateChange)="handleValueChange(field.fieldName)"
            >
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            >
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }
        @case ('textarea') {
          <mat-form-field
            appearance="outline"
            class="form-field-textarea"
            [class]="getFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="3"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            ></textarea>
          </mat-form-field>
        }
      }
    }
  </form>
  @if (!turnkeyCostData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          type="button"
          (click)="handelDelete()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        type="button"
        [disabled]="!turnkeyCostFormGroup().valid"
        (click)="handelCreate()"
      >
        Сохранить
      </button>
    </div>
  }
</div>
